import React from "react";
import style from "./DoubleButton.module.scss";
import classnames from "classnames";

interface DoubleButtonProps {
  selected: "left" | "right";
  onLeftClick: () => void;
  onRightClick: () => void;
}

const DoubleButton: React.FC<DoubleButtonProps> = ({ onLeftClick, selected, onRightClick }) => {
  return (
    <div className={style.doubleButton}>
      <div className={classnames({ [style.doubleButton_selected]: selected === "left" })} onClick={onLeftClick}>
        top lifetime
      </div>
      <div className={classnames({ [style.doubleButton_selected]: selected === "right" })} onClick={onRightClick}>
        top today
      </div>
    </div>
  );
};

export default DoubleButton;
